import { styled } from '@mui/material';

export const AI_GRADIENT = 'linear-gradient(90deg, #A614FF 47.98%, #1F55F8 102.71%)';
export const AI_GRADIENT_ANIMATED = 'linear-gradient(90deg, #A614FF 0%, #1F55F8 50%, #A614FF 100%)';

export const AIGradientText = styled('span')({
  background: AI_GRADIENT,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 500,
});

export const AIGradientSpinner = styled('span')({
  display: 'inline-flex',
  width: '1rem',
  height: '1rem',
  borderRadius: '50%',
  flexShrink: 0,
  background: 'conic-gradient(#A614FF 0deg, #1F55F8 200deg, transparent 280deg)',
  WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), black 0)',
  mask: 'radial-gradient(farthest-side, transparent calc(100% - 2.5px), black 0)',
  '@keyframes aiSpin': {
    to: { transform: 'rotate(360deg)' },
  },
  animation: 'aiSpin 0.9s linear infinite',
});

export const aiGradientButtonSx = {
  background: AI_GRADIENT,
  color: 'white',
  fontWeight: 600,
  textTransform: 'none',
  borderRadius: '8px',
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT },
  '&.Mui-disabled': { opacity: 0.5, color: 'white' },
} as const;
